import type { PayloadAction } from "@reduxjs/toolkit";

/**
 * Shared parts of InventorySlice — plan §5.2. Only ONE reducer is shared; `saveInventoryData`
 * genuinely diverges and is authored per platform.
 *
 * ⚠️ **`saveInventoryData` is a REAL behaviour difference — do not unify it.**
 *   web:    `state.inventoryData = { ...state.inventoryData, ...action.payload }`  (MERGES)
 *   mobile: `state.inventoryData = action.payload`                                (REPLACES)
 *
 * Web's version also changes the CONTAINER TYPE: `inventoryData` starts as `[]`, and
 * spreading an array into an object literal yields a plain object — so after the first
 * `saveInventoryData` web holds `{...}` where the declared type still says `any[]`. That is
 * what the app ships, and consumers depend on the accumulate-across-calls behaviour, so it is
 * preserved verbatim. Both platform bodies are pinned by the runtime probe.
 *
 * ⚠️ `action` must be `PayloadAction<any>`, never `any` — see the ledger.
 */
export interface SharedInventoryState {
    inventoryData: any[]
}

export const sharedInitialState: SharedInventoryState = {
    inventoryData: []
}

/** Identical in both apps. `saveInventoryData` is NOT here — see the note above. */
export const sharedReducers = {
    getInventoryData: (state: SharedInventoryState, action: PayloadAction<any>) => {

    },
};
